var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "a-form-model",
        {
          staticClass: "user-layout-login",
          nativeOn: {
            keyup: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.handleSubmit($event)
            }
          }
        },
        [
          _c(
            "a-tabs",
            {
              attrs: {
                activeKey: _vm.customActiveKey,
                tabBarStyle: { textAlign: "center", borderBottom: "unset" }
              },
              on: { change: _vm.handleTabClick }
            },
            [
              _c(
                "a-tab-pane",
                {
                  key: "tab1",
                  attrs: { tab: _vm.language["system.loginTab"] }
                },
                [
                  _c("login-account", {
                    ref: "alogin",
                    on: {
                      validateFail: _vm.validateFail,
                      success: _vm.requestSuccess,
                      fail: _vm.requestFailed
                    }
                  })
                ],
                1
              ),
              _c(
                "a-tab-pane",
                { key: "tab2", attrs: { tab: "手机号登录" } },
                [
                  _c("login-phone", {
                    ref: "plogin",
                    on: {
                      validateFail: _vm.validateFail,
                      success: _vm.requestSuccess,
                      fail: _vm.requestFailed
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "a-form-model-item",
            [
              _c(
                "router-link",
                {
                  staticClass: "forge-password",
                  staticStyle: { float: "right" },
                  attrs: {
                    to: { name: "alteration", query: { type: "password" } }
                  }
                },
                [
                  _vm._v(
                    "\n          " + _vm._s(_vm.language["sys.forget.password"])
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "a-form-item",
            { staticStyle: { "margin-top": "24px" } },
            [
              _c(
                "a-button",
                {
                  staticClass: "login-button",
                  attrs: {
                    size: "large",
                    type: "primary",
                    htmlType: "submit",
                    disabled: _vm.loginBtn
                  },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.handleSubmit($event)
                    }
                  }
                },
                [
                  _vm._v(
                    _vm._s(_vm.language["system.loginButton"]) + "\n        "
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.requiredTwoStepCaptcha
        ? _c("two-step-captcha", {
            attrs: { visible: _vm.stepCaptchaVisible },
            on: {
              success: _vm.stepCaptchaSuccess,
              cancel: _vm.stepCaptchaCancel
            }
          })
        : _vm._e(),
      _c("login-select-tenant", {
        ref: "loginSelect",
        on: { success: _vm.loginSelectOk, eror: _vm.loginSelectError }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }